<template>
  <Toast position="bottom-right">
    <template #message="slotProps">
      <div class="flex items-center gap-3">
        <FontAwesome
          :icon="slotProps.message.severity === 'success' ? 'check' : 'xmark'"
        />
        <div class="mr-3 flex flex-col">
          <span>
            {{ slotProps.message.summary }}
          </span>
          <a
            v-if="undoDelete || undoSave"
            class="text-gray-500 underline hover:cursor-pointer hover:text-gray-700"
            @click="
              undoDelete
                ? handleRestoreConcept(slotProps.message)
                : handleResetConcept(slotProps.message)
            "
          >
            {{ $t('p_Teacher.Undo') }}
          </a>
        </div>
      </div>
    </template>
  </Toast>
</template>

<script setup>
const { resetConcept, restoreConcept } = useConcepts()
const { resetQuiz } = useQuizQuestions()

const { undoDelete, triggerRefresh, undoSave } = storeToRefs(useUserStore())
const { addSuccessToast, addErrorToast } = useHelpers()
const toast = useToast()
const { t } = useI18n()

async function handleRestoreConcept(message) {
  const { error } = await restoreConcept(message.detail)

  if (error) {
    addErrorToast()
    return
  }

  undoDelete.value = false
  triggerRefresh.value = true
  toast.remove(message)
  addSuccessToast(t('p_Teacher.Concept restored successfully'))
}

function handleResetConcept(message) {
  toast.remove(message)
  undoSave.value = false
  if (message.detail === 'concept') {
    resetConcept()
    return
  }
  if (message.detail === 'quiz') {
    resetQuiz()
  }
}
</script>
